import { rotuloLadoVeiculo } from '../didatico/rotulosLado'

/** Peças que o Table top sabe abrir, afastar ou retirar, com o rótulo usado na interface. */
export const PECAS_INTERVENCAO_TABLETOP = [
  { id: 'portaDianteiraEsquerda', nome: `Porta dianteira do ${rotuloLadoVeiculo('esquerdo')}` },
  { id: 'portaDianteiraDireita', nome: `Porta dianteira do ${rotuloLadoVeiculo('direito')}` },
  { id: 'portaTraseiraEsquerda', nome: `Porta traseira do ${rotuloLadoVeiculo('esquerdo')}` },
  { id: 'portaTraseiraDireita', nome: `Porta traseira do ${rotuloLadoVeiculo('direito')}` },
  { id: 'colunaBEsquerda', nome: `Coluna B do ${rotuloLadoVeiculo('esquerdo')}` },
  { id: 'colunaBDireita', nome: `Coluna B do ${rotuloLadoVeiculo('direito')}` },
  { id: 'teto', nome: 'Teto' },
  { id: 'tampaTraseira', nome: 'Tampa traseira' },
] as const
